const C = {
  name: "FaceId",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 4C2 2.89228 2.89228 2 4 2H8V0H4C1.78772 0 0 1.78772 0 4V8H2V4Z" fill="currentColor"/>
<path d="M20 0H16V2H20C21.1077 2 22 2.89228 22 4V8H24V4C24 1.78772 22.2123 0 20 0Z" fill="currentColor"/>
<path d="M24 16V20C24 22.2123 22.2123 24 20 24H16V22H20C21.1077 22 22 21.1077 22 20V16H24Z" fill="currentColor"/>
<path d="M2 20V16H0V20C0 22.2123 1.78772 24 4 24H8V22H4C2.89228 22 2 21.1077 2 20Z" fill="currentColor"/>
<path d="M8.70718 16.293L8.93718 16.523C9.88016 17.4659 11.166 18.0001 12.5001 18.0001C13.8341 18.0001 15.12 17.4659 16.063 16.523L16.293 16.293L17.7072 17.7072L17.4772 17.9372C16.1602 19.2542 14.366 20.0001 12.5001 20.0001C10.6341 20.0001 8.83999 19.2542 7.52297 17.9372L7.29297 17.7072L8.70718 16.293Z" fill="currentColor"/>
<path d="M5.70718 8.70711C6.16001 8.25428 6.77581 8 7.41008 8H7.58008C8.22278 8 8.82903 8.25317 9.28297 8.70711L10.6972 7.29289C9.87112 6.46683 8.75737 6 7.58008 6H7.41008C6.24434 6 5.12014 6.46572 4.29297 7.29289L5.70718 8.70711Z" fill="currentColor"/>
<path d="M16.4101 8C15.7758 8 15.16 8.25428 14.7072 8.70711L13.293 7.29289C14.1201 6.46572 15.2443 6 16.4101 6H16.5801C17.7574 6 18.8711 6.46683 19.6972 7.29289L18.283 8.70711C17.829 8.25317 17.2228 8 16.5801 8H16.4101Z" fill="currentColor"/>
<path d="M9.88965 13.31L12.2896 15.71L13.7096 14.29L12.1096 12.69L13.0296 8.99996L10.9796 8.95996L9.88965 13.31Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as FaceId
};
